import { render, staticRenderFns } from "./ScreeningProcess.vue?vue&type=template&id=3972dd1e&scoped=true&"
import script from "./ScreeningProcess.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcess.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProcess.vue?vue&type=style&index=0&id=3972dd1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972dd1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VProgressLinear,VRow})
